import store from "../../../store";
import { DatabaseInstance } from "../../../utils/databaseClass";
import { USER_EXPERIENCE_UPDATE_BULK, USER_EXPERIENCE_UPDATE_SINGLE } from "../slices";

class UserExperienceClass {
  public attendExperience = async (experienceId: number) => {
    const endpoint = `experiences/purchase-experience/${experienceId}`;

    const { newUserExperience = null } = await DatabaseInstance.createRecord({
      endpoint,
      data: {},
    });

    if (!newUserExperience) return null;

    store.dispatch(USER_EXPERIENCE_UPDATE_SINGLE({ data: newUserExperience }));

    return newUserExperience;
  };

  public getUserExperiences = async (): Promise<any[]> => {
    const endpoint = `experiences/get-purchased-experiences`;

    const userExperiences = await DatabaseInstance.getRecord({ endpoint });

    store.dispatch(
      USER_EXPERIENCE_UPDATE_BULK({
        data: userExperiences,
      }),
    );

    return userExperiences;
  };
}

export const UserExperienceInstance = new UserExperienceClass();
